import style from './index.module.scss'

export function SpinnerLoader() {
    return (
        <div className={style.center}>
            <div className={style.loader}></div>
        </div>
    )
}
